import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import {HomeService} from "./home.service";
declare var $: any;


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  importform: FormGroup;
  // homeinfo: Home;
  constructor(
    private homeService:HomeService,
    private router: Router,
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute,
) {
   
}

  ngOnInit() {
    debugger
    this.importform = this.fb.group({
        userfile: ['',
            Validators.required,
        ],
        url_data: ['',
            Validators.required
        ],
        
        // vSlug: ['',
        //     Validators.required
        // ]
    });

    
    this.getDashboardData();

  }
  getDashboardData=function(){
      // this.homeService.getDashboardData().then(data => {
      //     console.log("DashboardData =======>",data);
          this.totalusers = 0;
          this.activeusers = 0;
      // });
  }

  onSubmit(pageValue) {
      this.importData(pageValue);
  }


  onFileChange($event) {
    console.log("EVENT =====> ",$event);
    if($event.target.files.length > 0) {
        let file = $event.target.files[0]; // <--- File Object for future use.
        console.log("FILE ===> ",file.name);
        this.importform.get('url_data').setValue(file.name);
        this.importform.get('userfile').setValue(file); // <-- Set Value for Validation
    }else{
        this.importform.get('url_data').setValue('');
    }
  }

  private prepareSave(): any {
    let input = new FormData();
    // This can be done a lot prettier; for example automatically assigning values by looping through `this.form.controls`, but we'll keep it as simple as possible here
    input.append('userfile',this.importform.get('userfile').value);
    return input;
  }

  importData(pageValue){
    $('#save_page').button('loading');
    const formModel = this.prepareSave();
    console.log(formModel)
    this.homeService.importUserData(formModel).then(PageData => {
        if(PageData['code'] === 200){
            $('#save_page').button('reset');
            $.toast({heading: 'Success', text: PageData['msg'], position: 'top-right', showHideTransition: 'slide', icon: 'success'});
            // this.router.navigate(['/pages']);
        }else{
            $.toast({heading: 'Warning', text: PageData['msg'], position: 'top-right', showHideTransition: 'slide', icon: 'warning'});
            $('#save_page').button('reset');
        }
    }).catch(err => {
        if(err['code'] != 200){
            $.toast({heading: 'Error', text: err['msg'], position: 'top-right', showHideTransition: 'slide', icon: 'error'});
        }else{
            $.toast({heading: 'Error', text: 'Server error! Please try again later', position: 'top-right', showHideTransition: 'slide', icon: 'error'});
        }
        $('#save_page').button('reset');
    });
}

}



// WEBPACK FOOTER //
// /home/sotsys211/work/src/ecard_new/backend/src/app/home/home.component.ts